import OnboardingLocationMotivation from 'registration/components/new_pages/OnboardingLocationMotivation/OnboardingLocationMotivation';

export default OnboardingLocationMotivation;
